import { graphql } from 'gatsby';

import indexPageWrapper from '../components/IndexPage';

const indexPage = indexPageWrapper('resources');

export default indexPage;

/* eslint-disable no-undef */
export const pageQuery = graphql`
  query ResourcesQuery {
    site {
      siteMetadata {
        title
      }
    }
    allMarkdownRemark(filter: {frontmatter: {path: {regex: "/^\/resources/i" }}}) {
      edges {
        node {
          id
          html
          frontmatter {
            path
            title
            menuOrder
          }
        }
      }
    }
  }
`;
